/* eslint-disable no-unused-vars */
import PropTypes from 'prop-types';
import React from 'react';

import IconButton from '@mui/material/IconButton';

import TableCell from '@mui/material/TableCell';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ActionsCell = ({
  canHaveSubItems,
  addNewItemToSubLayer,
  provided,
  deleteRowFromCurrentLayer,
}) => (
  <TableCell align="center">
    <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
      <IconButton
        size="small"
        sx={{ visibility: canHaveSubItems ? 'visible' : 'hidden' }}
        onClick={addNewItemToSubLayer}
      >
        <FontAwesomeIcon icon="turn-down" style={{ fontSize: '16px' }} />
      </IconButton>
      <IconButton size="small">
        <span {...provided.dragHandleProps}>
          <FontAwesomeIcon icon="grip-vertical" />
        </span>
      </IconButton>

      <IconButton onClick={deleteRowFromCurrentLayer} size="large">
        <FontAwesomeIcon icon="trash" style={{ fontSize: '16px' }} />
      </IconButton>
    </div>
  </TableCell>
);

ActionsCell.propTypes = {
  deleteRowFromCurrentLayer: PropTypes.func,
  canHaveSubItems: PropTypes.bool,
  addNewItemToSubLayer: PropTypes.func,
  iconSize: PropTypes.string,
  addNewItemSubLayerIconStyle: PropTypes.shape({
    color: PropTypes.string,
    fontSize: PropTypes.number,
  }),
  dragIconStyle: PropTypes.shape({
    cursor: PropTypes.string,
    color: PropTypes.string,
    fontSize: PropTypes.string,
    marginTop: PropTypes.string,
  }),
  deleteIconStyle: PropTypes.shape({
    cursor: PropTypes.string,
    color: PropTypes.string,
  }),
  provided: PropTypes.shape({
    dragHandleProps: PropTypes.shape({
      onMouseDown: PropTypes.func,
      onTouchStart: PropTypes.func,
    }).isRequired,
  }).isRequired,
};

ActionsCell.defaultProps = {
  iconSize: 'medium',
  canHaveSubItems: false,
  deleteRowFromCurrentLayer: () => {},
  addNewItemToSubLayer: () => {},
  addNewItemSubLayerIconStyle: {
    color: '',
    fontSize: '',
  },
  dragIconStyle: {
    cursor: '',
    color: '',
    fontSize: '',
    marginTop: '',
  },
  deleteIconStyle: {
    cursor: '',
    color: '',
  },
};
